import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=71f7a50c&scoped=true&"
import script from "./Group.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Group.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./Group.vue?vue&type=style&index=0&id=71f7a50c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f7a50c",
  null
  
)

export default component.exports